import { IconBasket } from 'components/Shared/Icon/themes/BGH-RD3/iconBasket';
import styles from './styles.scss';
import connect from 'components/Shared/connect';
import { getCheckoutLink, getCartItemQuantity } from 'components/Basket/selector';
import { rm } from 'utils';
import { getQaDataAttr } from '@bygghemmait/utilities';
import cn from 'classnames';

interface OwnProps {
  className?: string;
}
interface MergedProps extends OwnProps {
  url: string;
  quantity: number;
}

const _MobileBasket = ({ url, className, quantity }: MergedProps) => (
  <a href={url} className={cn(styles.mobileBasket, className)} {...getQaDataAttr('checkout')}>
    <IconBasket className={styles.mobileCartIcon} />
    <span className={styles.caption}>{rm('checkout')}</span>
    <Quantity quantity={quantity} />
  </a>
);

const Quantity = ({ quantity }: Pick<MergedProps, 'quantity'>) => (
  <div className={styles.quantity}>
    <p className={styles.quantityText}>{quantity}</p>
  </div>
);

export const MobileBasket = connect<MergedProps, OwnProps>(state => ({
  quantity: getCartItemQuantity(state),
  url: getCheckoutLink(state)
}))(_MobileBasket);
